import 'css-chunksrc/feature/provision/StepperFooter.module.scss';export default {
  "container": "StepperFooter_container"
};